<template>
  <div class="summary-head" :class="classname">
    <div class="sminner">
      <BreadCrumbs>
        <li class="bcli"><slot name="title01"></slot></li>
      </BreadCrumbs>
      <h1 class="smtitle"><slot name="title01"></slot></h1>
      <p class="smtxt">
        <slot name="txt"></slot>
      </p>
    </div><!-- sminner -->
  </div><!-- summary head -->
</template>

<script>
export default {
  props: ["summaryClass"],
  data() {
    return {
      classname: this.summaryClass,
    };
  }
};
</script>